import { render, staticRenderFns } from "./notificationMenu.vue?vue&type=template&id=31fadc1a&scoped=true"
import script from "./notificationMenu.vue?vue&type=script&lang=js"
export * from "./notificationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fadc1a",
  null
  
)

export default component.exports